window.RemzzzsMaskSkuData = [
  {
    sku: "K1-FS",
    title: "Full Face Kit — Small",
    type: "full-face",
    size: "small",
    description:
      "30-day liner kit sized for small full-face masks from ResMed, Philips Respironics, DeVilbiss, Roscoe, and Fisher & Paykel.",
    masks: [
      { name: "ResMed Mirage Quattro", sizes: ["S"] },
      { name: "ResMed Quattro Air", sizes: ["S"] },
      { name: "ResMed Quattro FX", sizes: ["S"] },
      { name: "ResMed Ultra Mirage", sizes: ["S"] },
      { name: "ResMed AirFit F10", sizes: ["S"] },
      { name: "ResMed AirFit F10 for Her", sizes: ["XS", "S"] },
      { name: "ResMed AirFit F20", sizes: ["S"] },
      { name: "ResMed AirFit F20 for Her", sizes: ["S"] },
      { name: "ResMed AirTouch F20", sizes: ["S"] },
      { name: "ResMed AirTouch F20 for Her", sizes: ["S"] },
      { name: "Philips Respironics Amara", sizes: ["P", "S"] },
      { name: "Philips Respironics ComfortFull 2", sizes: ["S"] },
      { name: "Philips Respironics ComfortGel", sizes: ["S"] },
      { name: "Philips Respironics Nasal EasyLife/Vista", sizes: ["M", "L"] },
      { name: "Philips Respironics FullLife", sizes: ["S"] },
      { name: "DeVilbiss Easy Fit", sizes: ["S"] },
      { name: "Roscoe DreamEasy", sizes: ["S"] },
      { name: "Roscoe CPM Full Face", sizes: ["S"] },
      { name: "Fisher & Paykel Simplus", sizes: ["S"] },
      { name: "Fisher & Paykel Vitera", sizes: ["S"] }
    ]
  },
  {
    sku: "K4-FS",
    title: "Full Face Kit — Small (FlexiFit/Forma)",
    type: "full-face",
    size: "small",
    description: "Small liner kit sized for Fisher & Paykel FlexiFit/Forma masks and the Hans Rudolph 7600 V2.",
    masks: [
      { name: "Fisher & Paykel FlexiFit 431", sizes: ["S"] },
      { name: "Fisher & Paykel FlexiFit 432", sizes: ["S"] },
      { name: "Fisher & Paykel Forma", sizes: ["S"] },
      { name: "Hans Rudolph 7600 V2", sizes: ["S"] }
    ]
  },
  {
    sku: "K2-FM",
    title: "Full Face Kit — Medium",
    type: "full-face",
    size: "medium",
    description: "30-day liner kit covering medium full-face cushions from ResMed, Philips Respironics, DeVilbiss, Roscoe, and Fisher & Paykel.",
    masks: [
      { name: "ResMed Mirage Quattro", sizes: ["M"] },
      { name: "ResMed Quattro Air", sizes: ["M"] },
      { name: "ResMed Quattro FX", sizes: ["M", "L"] },
      { name: "ResMed Ultra Mirage", sizes: ["M"] },
      { name: "ResMed AirFit F10", sizes: ["M"] },
      { name: "ResMed AirFit F10 for Her", sizes: ["M"] },
      { name: "ResMed AirFit F20", sizes: ["M"] },
      { name: "ResMed AirFit F20 for Her", sizes: ["M"] },
      { name: "ResMed AirTouch F20", sizes: ["M"] },
      { name: "ResMed AirTouch F20 for Her", sizes: ["M"] },
      { name: "Philips Respironics Amara", sizes: ["M"] },
      { name: "Philips Respironics ComfortFull 2", sizes: ["M"] },
      { name: "Philips Respironics ComfortGel", sizes: ["M"] },
      { name: "Philips Respironics FullLife", sizes: ["M"] },
      { name: "DeVilbiss Easy Fit", sizes: ["M"] },
      { name: "Roscoe DreamEasy", sizes: ["M"] },
      { name: "Roscoe CPM Full Face", sizes: ["M"] },
      { name: "Fisher & Paykel Simplus", sizes: ["M"] },
      { name: "Fisher & Paykel Vitera", sizes: ["M"] }
    ]
  },
  {
    sku: "K5-FM",
    title: "Full Face Kit — Medium (FlexiFit/Forma)",
    type: "full-face",
    size: "medium",
    description: "Medium liner kit sized for Fisher & Paykel FlexiFit/Forma masks and the Hans Rudolph 7600 V2.",
    masks: [
      { name: "Fisher & Paykel FlexiFit 431", sizes: ["M"] },
      { name: "Fisher & Paykel FlexiFit 432", sizes: ["M"] },
      { name: "Fisher & Paykel Forma", sizes: ["M"] },
      { name: "Hans Rudolph 7600 V2", sizes: ["M"] }
    ]
  },
  {
    sku: "K6-FL",
    title: "Full Face Kit — Large (FlexiFit/Forma)",
    type: "full-face",
    size: "large",
    description: "Large liner kit covering Fisher & Paykel FlexiFit/Forma masks and the Hans Rudolph 7600 V2.",
    masks: [
      { name: "Fisher & Paykel FlexiFit 431", sizes: ["L"] },
      { name: "Fisher & Paykel FlexiFit 432", sizes: ["L"] },
      { name: "Fisher & Paykel Forma", sizes: ["L"] },
      { name: "Hans Rudolph 7600 V2", sizes: ["L"] }
    ]
  },
  {
    sku: "6A-FLK",
    title: "Total Face Kit — Respironics FitLife (S/L)",
    type: "total-face",
    size: "small-large",
    description: "Universal total-face liner for Philips Respironics FitLife in small and large sizes.",
    masks: [
      { name: "Philips Respironics FitLife", sizes: ["S", "L"] }
    ]
  },
  {
    sku: "6B-FLK",
    title: "Total Face Kit — Respironics FitLife (XL)",
    type: "total-face",
    size: "extra-large",
    description: "XL total-face liner dedicated to the Philips Respironics FitLife mask.",
    masks: [
      { name: "Philips Respironics FitLife", sizes: ["XL"] }
    ]
  },
  {
    sku: "K3-FL",
    title: "Full Face Kit — Large",
    type: "full-face",
    size: "large",
    description: "30-day liner kit covering large full-face cushions from ResMed, Philips Respironics, DeVilbiss, Roscoe, and Fisher & Paykel.",
    masks: [
      { name: "ResMed Mirage Quattro", sizes: ["L"] },
      { name: "ResMed Quattro Air", sizes: ["L"] },
      { name: "ResMed Ultra Mirage", sizes: ["L"] },
      { name: "ResMed AirFit F10", sizes: ["L"] },
      { name: "ResMed AirFit F20", sizes: ["L"] },
      { name: "ResMed AirTouch F20", sizes: ["L"] },
      { name: "Philips Respironics ComfortGel", sizes: ["L"] },
      { name: "Philips Respironics Amara", sizes: ["L"] },
      { name: "Philips Respironics ComfortFull 2", sizes: ["L"] },
      { name: "Philips Respironics FullLife", sizes: ["L"] },
      { name: "DeVilbiss Easy Fit", sizes: ["L"] },
      { name: "Roscoe DreamEasy", sizes: ["L"] },
      { name: "Roscoe CPM Full Face", sizes: ["L"] },
      { name: "Fisher & Paykel Simplus", sizes: ["L"] },
      { name: "Fisher & Paykel Vitera", sizes: ["L"] }
    ]
  },
  {
    sku: "6C-AVK",
    title: "Minimal Contact Full Face Kit — Universal",
    type: "minimal-contact",
    size: "universal",
    description:
      "Universal liner for under-the-nose full face masks like the Amara View, DreamWear Full Face, Evora Full, and ResMed F30/F30i/F40 families.",
    masks: [
      { name: "Philips Respironics Amara View", sizes: ["S", "M", "L"] },
      { name: "Philips Respironics DreamWear Full Face", sizes: ["S", "M", "L", "M-Wide"] },
      { name: "Fisher & Paykel Evora Full Face", sizes: ["XS", "S/M", "L"] },
      { name: "ResMed AirFit F30", sizes: ["S", "M"] },
      { name: "ResMed AirFit F30i", sizes: ["S", "M", "S-Wide", "Wide"] },
      { name: "ResMed AirTouch F30i Clear", sizes: ["S-Wide", "M", "L"] },
      { name: "ResMed AirFit F40", sizes: ["S-Wide", "M", "L"] }
    ]
  },
  {
    sku: "6F-30K",
    title: "Minimal Contact Full Face Kit — Enhanced",
    type: "minimal-contact",
    size: "universal",
    description: "Alternate minimal-contact liner with additional coverage for ResMed F30/F30i/F40 style cushions.",
    masks: [
      { name: "ResMed AirFit F30", sizes: ["S", "M"] },
      { name: "ResMed AirFit F30i", sizes: ["S", "M", "S-Wide", "Wide"] },
      { name: "ResMed AirTouch F30i Clear", sizes: ["S-Wide", "M", "L"] },
      { name: "ResMed AirFit F40", sizes: ["S-Wide", "M", "L"] }
    ]
  },
  {
    sku: "K7-NS",
    title: "Nasal Kit — Small (Respironics)",
    type: "nasal",
    size: "small",
    description: "Small nasal liner kit covering Philips Respironics classics plus DeVilbiss and AG Sopora cushions.",
    masks: [
      { name: "Philips Respironics ComfortClassic", sizes: ["S"] },
      { name: "Philips Respironics ComfortFusion", sizes: ["S"] },
      { name: "Philips Respironics ComfortGel Nasal", sizes: ["S"] },
      { name: "Philips Respironics ComfortSelect", sizes: ["S"] },
      { name: "Philips Respironics ProfileLite", sizes: ["S"] },
      { name: "DeVilbiss Easy Fit Nasal", sizes: ["S"] },
      { name: "AG Sopora", sizes: ["S"] }
    ]
  },
  {
    sku: "7A-NPK",
    title: "Nasal Pillow Kit — Universal",
    type: "nasal-pillow",
    size: "universal",
    description: "Universal nasal pillow liner that fits the most common pillow-style masks from ResMed, Philips Respironics, Fisher & Paykel, React Health, and TAP PAP.",
    masks: [
      { name: "ResMed AirFit P30i", sizes: ["All"] },
      { name: "ResMed AirFit P10", sizes: ["All"] },
      { name: "ResMed AirFit P10 for Her", sizes: ["All"] },
      { name: "ResMed Swift FX", sizes: ["All"] },
      { name: "ResMed Swift FX for Her", sizes: ["All"] },
      { name: "Philips Respironics Nuance Pro Gel Nasal Pillow", sizes: ["All"] },
      { name: "Fisher & Paykel Opus 360", sizes: ["All"] },
      { name: "React Health Rio II Nasal Pillow", sizes: ["All"] },
      { name: "TAP PAP Nasal Pillows", sizes: ["All"] }
    ]
  },
  {
    sku: "K10-NS",
    title: "Nasal Kit — Small (ResMed/F&P)",
    type: "nasal",
    size: "small",
    description: "Small nasal liner kit aligned to ResMed Activa/AirFit/AirTouch N-series, Mirage FX for Her, Fisher & Paykel FlexiFit sizes, plus TrueBlue/Wisp/Pico in larger cushions.",
    masks: [
      { name: "ResMed Activa / Activa LT", sizes: ["S"] },
      { name: "ResMed AirFit N10", sizes: ["Standard"] },
      { name: "ResMed AirFit N20", sizes: ["M"] },
      { name: "ResMed AirTouch N20", sizes: ["M"] },
      { name: "ResMed Mirage FX for Her", sizes: ["Standard"] },
      { name: "ResMed SoftGel", sizes: ["S"] },
      { name: "ResMed Mirage Micro", sizes: ["S"] },
      { name: "ResMed Swift FX Nano", sizes: ["Standard"] },
      { name: "ResMed Ultra Mirage II", sizes: ["Shallow", "Wide"] },
      { name: "Fisher & Paykel FlexiFit 405", sizes: ["S/M"] },
      { name: "Fisher & Paykel FlexiFit 406", sizes: ["Petite"] },
      { name: "Philips Respironics TrueBlue", sizes: ["M", "M-Wide", "L"] },
      { name: "Philips Respironics Wisp", sizes: ["L", "XL"] },
      { name: "Philips Respironics Pico", sizes: ["L"] }
    ]
  },
  {
    sku: "10A-NXK",
    title: "Nasal Kit — Extra Small",
    type: "nasal",
    size: "extra-small",
    description: "Extra small nasal liner kit tailored to petite ResMed N-series cushions, Fisher & Paykel Zest/Eson petite sizes, and petite Philips Respironics options.",
    masks: [
      { name: "ResMed Swift FX Nano for Her", sizes: ["XS", "S"] },
      { name: "ResMed AirFit N10", sizes: ["S"] },
      { name: "ResMed AirFit N10 for Her", sizes: ["S"] },
      { name: "ResMed AirFit N20", sizes: ["S"] },
      { name: "ResMed AirFit N20 for Her", sizes: ["S"] },
      { name: "ResMed AirTouch N20", sizes: ["S"] },
      { name: "ResMed AirTouch N20 for Her", sizes: ["S"] },
      { name: "ResMed Mirage FX for Her", sizes: ["S"] },
      { name: "Fisher & Paykel Zest Petite", sizes: ["S"] },
      { name: "Fisher & Paykel Eson", sizes: ["S"] },
      { name: "Fisher & Paykel Eson 2", sizes: ["S"] },
      { name: "Philips Respironics TrueBlue", sizes: ["P", "S"] },
      { name: "Philips Respironics Wisp", sizes: ["P", "S/M"] },
      { name: "Philips Respironics Pico", sizes: ["S/M"] }
    ]
  },
  {
    sku: "K8-NM",
    title: "Nasal Kit — Medium (Respironics)",
    type: "nasal",
    size: "medium",
    description: "Medium nasal liner kit geared toward Philips Respironics classics plus DeVilbiss and AG Sopora.",
    masks: [
      { name: "Philips Respironics Pico", sizes: ["XL"] },
      { name: "Philips Respironics ComfortClassic", sizes: ["M"] },
      { name: "Philips Respironics ComfortFusion", sizes: ["M"] },
      { name: "Philips Respironics ComfortGel Nasal", sizes: ["M"] },
      { name: "Philips Respironics ComfortSelect", sizes: ["M"] },
      { name: "Philips Respironics ProfileLite", sizes: ["M"] },
      { name: "DeVilbiss Easy Fit Nasal", sizes: ["M"] },
      { name: "AG Sopora", sizes: ["M"] }
    ]
  },
  {
    sku: "K11-NM",
    title: "Nasal Kit — Medium (ResMed/F&P)",
    type: "nasal",
    size: "medium",
    description: "Medium nasal liner kit aligned to ResMed Activa/AirFit/AirTouch families plus Fisher & Paykel Eson/Zest/FlexiFit sizes.",
    masks: [
      { name: "ResMed Activa / Activa LT", sizes: ["M"] },
      { name: "ResMed AirFit N10", sizes: ["Wide"] },
      { name: "ResMed AirFit N20", sizes: ["L"] },
      { name: "ResMed AirTouch N20", sizes: ["L"] },
      { name: "ResMed Mirage FX", sizes: ["Standard", "Wide"] },
      { name: "ResMed Mirage Micro", sizes: ["M"] },
      { name: "ResMed SoftGel", sizes: ["M"] },
      { name: "ResMed Ultra Mirage II", sizes: ["Standard", "M"] },
      { name: "ResMed Swift FX Nano", sizes: ["Wide"] },
      { name: "Fisher & Paykel Eson", sizes: ["M"] },
      { name: "Fisher & Paykel Eson 2", sizes: ["M"] },
      { name: "Fisher & Paykel Zest", sizes: ["Standard"] },
      { name: "Fisher & Paykel FlexiFit 405", sizes: ["M/L"] },
      { name: "Fisher & Paykel FlexiFit 407", sizes: ["Standard"] }
    ]
  },
  {
    sku: "K9-NL",
    title: "Nasal Kit — Large (Respironics)",
    type: "nasal",
    size: "large",
    description: "Large nasal liner kit covering Philips Respironics classics plus DeVilbiss and AG Sopora cushions.",
    masks: [
      { name: "Philips Respironics ComfortClassic", sizes: ["L"] },
      { name: "Philips Respironics ComfortFusion", sizes: ["L"] },
      { name: "Philips Respironics ComfortGel Nasal", sizes: ["L"] },
      { name: "Philips Respironics ComfortSelect", sizes: ["L"] },
      { name: "Philips Respironics ProfileLite", sizes: ["L"] },
      { name: "DeVilbiss Easy Fit Nasal", sizes: ["L"] },
      { name: "AG Sopora", sizes: ["L"] }
    ]
  },
  {
    sku: "K12-NL",
    title: "Nasal Kit — Large (ResMed/F&P)",
    type: "nasal",
    size: "large",
    description: "Large nasal liner kit aligned to ResMed Activa/Mirage/SoftGel and Fisher & Paykel Eson/Zest families.",
    masks: [
      { name: "ResMed Activa / Activa LT", sizes: ["L"] },
      { name: "ResMed Mirage Micro", sizes: ["L"] },
      { name: "ResMed SoftGel", sizes: ["L"] },
      { name: "ResMed Ultra Mirage II", sizes: ["L"] },
      { name: "Philips Respironics EasyLife/Vista", sizes: ["S"] },
      { name: "Fisher & Paykel Eson", sizes: ["L"] },
      { name: "Fisher & Paykel Eson 2", sizes: ["L"] },
      { name: "Fisher & Paykel Zest / Zest Plus", sizes: ["L"] }
    ]
  }
];
